import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useGetAdherent } from '../../../hooks/useGetAdherent';
import { RootState } from '../../../redux/reducers';
import Api, { IApi } from '../../../services/Api';
import { AdherentParticulierResponse } from '../../../services/Api/swagger';
import { getApiEndpoint } from '../../../services/Config';
import { ErrorApi } from '../../../types';
import { setListeAdherents } from '../../../redux/AdherentRedux';

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAdherent = (infoCompte) => {
  const dispatch = useDispatch();

  const { listeAdherents } = useGetAdherent();

  const api: IApi = Api.create(getApiEndpoint() || 'http://localhost:8090'); // récupération de l'url de l'api (intégration, recette, production... )
  // USE MUTATION LISTE ADHERENTS
  const { mutate: getAdherentParticulierAdhesions, isLoading: fetchingAdherent, error: errorAdherent } = useMutation<
    AdherentParticulierResponse,
    ErrorApi,
    string
  >((data) => api?.getAdherentParticulierAdhesions(data), {
    // @ts-ignore
    onSuccess: (data: AdherentParticulierResponse, variables: string) => {
      dispatch(setListeAdherents(data));
    },
  });

  const offline = useReduxSelector((state) => state.global.offline);
  useEffect(() => {
    if (infoCompte && !listeAdherents) {
      dispatch(setListeAdherents(undefined));
      infoCompte.listeAdherents.forEach((adherent) => {
        adherent && getAdherentParticulierAdhesions(adherent.adherentParticulierId);
        // setFetchingAdherent(true);
        // adherent &&
        //   api["getAdherentParticulierAdhesions"](adherent.adherentParticulierId)
        //     .then((response) => {
        //       dispatch(setListeAdherents(response));
        //       setFetchingAdherent(false);
        //     })
        //     .catch(function (error) {
        //       setFetchingAdherent(false);
        //       setErrorAdherent(error);
        //     });
      });
    }
  }, [infoCompte]);

  return {
    fetchingAdherent,
    errorAdherent,
    listeAdherents,
  };
};
